'use strict';

(function () {
  'use strict';
  /**
   * When the button is clicked, this will attempt to fire off the referenced function in the same fashion as ng-click.
   * Additionally, this disables the button and adds a spinner until the function resolves its promise
   */

  // buttonLabel: Text that is displayed before the button is clicked.
  // successMessage: Congratulatory text that gets displayed when the button's clickAction returns successful.
  // errorMessage: Consulary text that gets displayed when the button's clickAction returns unsuccessful.
  // clickAction: A function that gets called when the element is clicked.


  // Spinner Button States:
  // Default: Inherits the default .btn styles of the environment it is in.
  // Disabled: If the element has a class 'disabled', the button will become slightly transparent.
  // Pending: While the button is waiting for a response from the server, clicking it will have no effect, but it will not appear disabled.
  // Pending2: If the response takes longer than 250ms, a spinner will appear to the left of the button, and disappear when the request is completed.
  // Success: If the response is successful, the 'successMessage' gets displayed.
  // Error: If the response returns an error, the 'errorMessage' gets displayed.
  // Reset: The Success/Error Message gets replaced by the default buttonLabel.

  angular.module('msCore').directive('spinnerButton', spinnerButton);

  spinnerButton.$inject = ['$parse', '$q', '$timeout', '$log'];

  function spinnerButton($parse, $q, $timeout, $log) {
    var directive = {
      restrict: 'EA',
      scope: {
        buttonLabel: '@',
        successMessage: '@',
        errorMessage: '@',
        clickAction: '&'
      },
      templateUrl: 'core/templates/spinner-button.html',
      link: link
    };

    function link(scope, element, attr) {

      // Set all the initial values
      scope.showSpinner = false;
      scope.pending = false;
      scope.success = false;
      scope.error = false;
      // Add the ARIA button role.
      element[0].setAttribute('role', 'button');

      attr.$observe('ngDisabled', function (value) {
        if (scope.$eval(value)) {
          element.addClass('disabled');
          element[0].setAttribute('tabindex', '-1');
        } else {
          element.removeClass('disabled');
          element[0].setAttribute('tabindex', '0');
        }
      });

      bindClickAndKeyEvents(element, scope, $timeout, $q, $log);
    }
    return directive;
  }

  function bindClickAndKeyEvents(element, scope, $timeout, $q, $log) {

    element.on('click keyup', function (event) {

      // 13 == 'enter', 32 == 'spacebar'
      var triggerKeys = [13, 32];
      // Allow the user to press "enter" or "space" to activiate this button.
      if (event.keyCode && !triggerKeys.includes(event.keyCode)) {
        return;
      }

      if (scope.$eval(element.attr.ngDisabled)) {
        $log.info('This button is disabled by the `ng-disabled` attribute.');
        return;
      }
      if (scope.pending) {
        $log.info('This button is disabled because it is currently waiting for a response from the server.');
        return;
      }
      // If the button is not disabled, and is not waiting for a reaponse from the server (pending),
      // then continue.

      // Only show the spinner if the request takes longer than 1/4sec.
      // The the response takes less than 250ms, this $timeout will be canceled.
      var spinnerPatience = $timeout(function () {
        scope.showSpinner = true;
      }, 250);

      setButtonToPending(scope, element);

      // $q.when() is used in case the
      // clickAction function does not return a promise
      $q.when(scope.clickAction(scope, {
        $event: event
      })).then(function () {
        scope.success = true;
        resetButton(scope, element, $timeout, spinnerPatience);
      }, function (err) {
        scope.error = true;
        resetButton(scope, element, $timeout, spinnerPatience);
        return err;
      });
    });
  }

  function setButtonToPending(scope, element) {
    scope.pending = true;
    element.addClass('pending');
  }

  function resetButton(scope, element, $timeout, timeoutToCancel) {
    $timeout.cancel(timeoutToCancel);
    $timeout(function () {
      scope.showSpinner = false;
    }, 500);
    $timeout(function () {
      element.removeClass('pending');
      scope.pending = false;
      scope.success = false;
      scope.error = false;
    }, 3000);
  }
})();